var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var GridIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 45,
    glyphHeight: 45
  }), React.createElement("path", {
    d: "M10.3251 0.170898H0.171631V10.3244H10.3251V0.170898Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M27.2484 0.170898H17.0949V10.3244H27.2484V0.170898Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M44.1716 0.170898H34.0181V10.3244H44.1716V0.170898Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M10.3251 17.0938H0.171631V27.2472H10.3251V17.0938Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M27.2484 17.0938H17.0949V27.2472H27.2484V17.0938Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M44.1716 17.0938H34.0181V27.2472H44.1716V17.0938Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M10.3251 34.0156H0.171631V44.1691H10.3251V34.0156Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M27.2484 34.0156H17.0949V44.1691H27.2484V34.0156Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M44.1716 34.0156H34.0181V44.1691H44.1716V34.0156Z",
    fill: "black"
  }));
};
export var GridIconGlyph = function (props) {
  return React.createElement(GridIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};